// extracted by mini-css-extract-plugin
export default {"heading":"deficiencies_heading__SpZRd","heading--resolved":"deficiencies_heading--resolved__S17KE","tabs":"deficiencies_tabs__XV4UR","buttons":"deficiencies_buttons__Cj1wC"};